let SCHEME;
let BASE_URL;
let APP_BASE_URL;

if (process.env.NODE_ENV === "local") {
  SCHEME = "https";
  BASE_URL = "test.easyboard.co.in";
  APP_BASE_URL = BASE_URL;
} else if (process.env.NODE_ENV === "development") {
  SCHEME = "https";
  BASE_URL = "test.easyboard.co.in";
  APP_BASE_URL = BASE_URL;
} else if (process.env.NODE_ENV === "staging") {
  SCHEME = "https";
  BASE_URL = "staging.easyboard.co.in";
  APP_BASE_URL = BASE_URL;
} else if (process.env.NODE_ENV === "production") {
  SCHEME = "https";
  BASE_URL = "easyboard.co.in";
  APP_BASE_URL = BASE_URL;
} else {
  SCHEME = "https";
  BASE_URL = "test.easyboard.co.in";
  APP_BASE_URL = BASE_URL;
}

export const API_ROOT = `${SCHEME}://api.${BASE_URL}/`;
export const DEVICE_REPORT = `${SCHEME}://devices.${BASE_URL}/download-device-report`;
export const DEVICES_REPORT = `${SCHEME}://devices.${BASE_URL}`;
export const API_AUTH_ROOT = `${API_ROOT}auth`;
export const APP_ROOT = `${SCHEME}://app.${BASE_URL}`;

export const ADMIN_ROOT = `${SCHEME}://admin.${BASE_URL}`;
export const APP_URL = `${SCHEME}://app.${APP_BASE_URL}`;

export const CUSTOM_API_ROOT = `${SCHEME}://admin.${BASE_URL}`;

export const TICKER_SPEEDS = [
  { value: 100, label: "Fastest" },
  { value: 200, label: "Faster" },
  { value: 300, label: "Fast" },
  { value: 400, label: "Normal" },
  { value: 500, label: "Slow" },
  { value: 600, label: "Slower" },
  { value: 700, label: "Slowest" },
];

export const AVAILABLE_FONTS = [
  { value: "serif", label: "Serif" },
  { value: "sans-serif", label: "Sans-Serif" },
  { value: "monospace", label: "monospace" },
];

export const TICKER_DEFAULTS = {
  text: "",
  speed: 400,
  font_family: "sans-serif",
  font_size: 22,
  colour: "#FFFFFF",
  outline: null,
  background: "#000000",
};

`
Application Permissions

asset
playlist
devicegroup
airveda
airquality
devicegroup
aqiveda asset
web asset
url asset
image asset
pdf asset
video asset
calendar asset
feed asset
fids asset
playlist
playlist_item
ticker
ticker series
content_feed
`;

export const grapejsConfig = (html) => {
  return {
    // Indicate where to init the editor. You can also pass an HTMLElement
    container: "#gjs",
    // Get the content for the canvas directly from the element
    // As an alternative we could use: `components: '<h1>Hello World Component!</h1>'`,
    fromElement: false,
    plugins: ["gjs-preset-webpage", "grapesjs-touch"],
    pluginsOpts: {
      "gjs-preset-webpage": {
        // options
      },
    },
    allowScripts: 1,
    // Size of the editor
    height: "700px",
    width: "auto",
    components: html,
    // Disable the storage manager for the moment
    storageManager: false,
    blockManager: {
      appendTo: "#blocks",
    },
    // layerManager: {
    //   appendTo: '.layers-container'
    // },
    // We define a default panel as a sidebar to contain layers
    panels: {
      defaults: [
        {
          id: "layers",
          el: ".panel__right",
          // Make the panel resizable
          resizable: {
            maxDim: 350,
            minDim: 200,
            tc: 0, // Top handler
            cl: 1, // Left handler
            cr: 0, // Right handler
            bc: 0, // Bottom handler
            // Being a flex child we need to change `flex-basis` property
            // instead of the `width` (default)
            keyWidth: "flex-basis",
          },
        },
        {
          id: "panel-switcher",
          el: ".panel__switcher",
          buttons: [
            {
              id: "show-layers",
              active: true,
              label: "Layers",
              command: "show-layers",
              // Once activated disable the possibility to turn it off
              togglable: false,
            },
            {
              id: "show-style",
              active: true,
              label: "Styles",
              command: "show-styles",
              togglable: false,
            },
          ],
        },
      ],
    },
    styleManager: {
      appendTo: ".styles-container",
    },
  };
};





// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/constants/config.js